import pathUrl from "./path"
import instance from './request'


const axios = instance;
const api = {
    getBooks() {
        return axios.get(pathUrl.baseUrl + "/analyze/books");
    },
    postBooks(bookName, bookAuthor) {
        return axios.post(pathUrl.baseUrl + "/analyze/books"), { 'name': bookName, 'author': bookAuthor };
    },
    getCheckMissionID(id) {
        return axios.get(pathUrl.baseUrl + "/analyze/checkmissionid/" + id);
    },
    getProteinLibrary() {
        return axios.get(pathUrl.baseUrl + "/analyze/proteinlibrary");
    },
    getSYNBIP() {
        return axios.get(pathUrl.baseUrl + "/analyze/synbip");
    },
    getVisitors() {
        return axios.get(pathUrl.baseUrl + "/analyze/getVisitors");
    },
    postAlignment(post_data) {
        return axios({
            method: "post",
            headers: {
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/analyze/alignment",
        });
    },
    postAlignmentSYNBIP(post_data) {
        return axios({
            method: "post",
            headers: {
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/analyze/alignment-synbip",
        });
    },
    // getAlignment(id) {
    //     return axios.get(pathUrl.baseUrl + "/analyze/alignment/" + id);
    // },
    getProgress(id) {
        return axios.get(pathUrl.baseUrl + "/analyze/progress/" + id);
    },

    getAlignresult(id) {
        return axios.get(pathUrl.baseUrl + "/analyze/alignresult/" + id);
    },

    postAligndetail(post_data) {
        return axios({
            method: "post",
            headers: {
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/analyze/detail",
        });
    },




    postContactUs(post_data) {
        return axios({
            method: "post",
            headers: {
                // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/analyze/contactus",
        });
    },

}

export default api;